import React from 'react';
import { motion } from 'framer-motion';
import { useReducedMotion } from '../../hooks/useReducedMotion';
import { pageTransition, fade } from '../../utils/animations';

interface PageTransitionProps {
  children: React.ReactNode;
  /** Unique key for AnimatePresence to track page changes */
  pageKey?: string;
}

/**
 * PageTransition - Wraps page content with entry/exit animations
 * 
 * Provides smooth slide + fade transitions between pages.
 * Respects reduced motion preferences.
 */
export const PageTransition: React.FC<PageTransitionProps> = ({ 
  children, 
  pageKey,
}) => {
  const prefersReducedMotion = useReducedMotion();
  
  // Use simpler fade for reduced motion
  const variants = prefersReducedMotion ? fade : pageTransition;
  
  return (
    <motion.div
      key={pageKey}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants}
      style={{ 
        width: '100%', 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
